import React from 'react';
import { useTranslation } from 'react-i18next';
import { Text, View } from 'react-native';

import { searchPageTestIDs, Theme } from '@constants';

const tPath = 'searchPage.';

export const SearchPage = () => {
  const { t } = useTranslation();

  return (
    <View style={Theme.styles.right}>
      <View style={Theme.styles.header}>
        <Text style={Theme.styles.headerText} testID={searchPageTestIDs.header}>
          {t(`${tPath}title`)}
        </Text>
      </View>
      <View>
        <Text>{t(`${tPath}body`)}</Text>
      </View>
    </View>
  );
};
